export default {
    CHECKED: 'CHECKED',
    DISABLED: 'DISABLED',
    DEFAULT: 'DEFAULT',
    STYLE: 'STYLE',
    LENGTH: 'LENGTH',
    REGEX: 'REGEX',
    REQUIRED: 'REQUIRED',
    RADIO: 'RADIO',
    CHECKBOX: 'CHECKBOX',
    DATE: 'DATE',
    ARRAY_TO_STRING: 'ARRAY_TO_STRING',
    STRING: 'STRING',
    CHECKED_TO_STRING: 'CHECKED_TO_STRING',
    PLACEHOLDER: 'PLACEHOLDER',
    PILLS: 'PILLS',
    INPUT: 'INPUT',
    TEXTAREA: 'TEXTAREA',
    SELECT: 'SELECT',
    DEFAULT_OUTPUT_KEY: 'DEFAULT_OUTPUT_KEY',
    DEFAULT_OUTPUT_KEY_INPUT: 'DEFAULT_OUTPUT_KEY_INPUT',
    DEFAULT_OUTPUT_KEY_SELECT: 'DEFAULT_OUTPUT_KEY_SELECT',
    DEFAULT_OUTPUT_KEY_TEXTAREA: 'DEFAULT_OUTPUT_KEY_TEXTAREA',
    DEFAULT_OUTPUT_KEY_PILL: 'DEFAULT_OUTPUT_KEY_PILL',
    DEFAULT_FORM_QUESTION_LABEL: "You have submitted the form",
    CHOICE: 'choice',
    V2: 'v2',
    DELIMITER: '&',
    FORM_SUBMISSION_ERROR: 'FORM_SUBMISSION_ERROR',
    FORM_SUBMISSION_SUCCESS: 'FORM_SUBMISSION_SUCCESS'
}
